<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionNumberTypeSelect
      [fixNgSelectBottom]="fractionNumberTypeSelect"
      data-cy="fractionNumberTypeSelect"
      class="fraction-type-select w-[270px]"
      [items]="fractionNumberTypesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.type"
      (change)="typeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionNumberTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionNumberTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div
          class="ml-1 truncate"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
          >{{ item.label }}</div
        >
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
        >
          <div class="ml-1">{{ item.operator | uppercase }} -</div>
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <form
    [formGroup]="numberValuesForm"
    *ngIf="
      fraction.type === fractionTypeEnum.NumberIsEqualTo ||
      fraction.type === fractionTypeEnum.NumberIsNotEqualTo
    "
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <fieldset [disabled]="isDisabled === true">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="fractionNumberValuesInput"
          class="rows form-input border-s3 focus:border-m600 h-[36px] w-[250px] resize-none rounded"
          [ngClass]="{
            'border-r600':
              numberValuesForm.controls['numberValues'].invalid &&
              numberValuesForm.controls['numberValues'].touched
          }"
          formControlName="numberValues"
          (blur)="numberValuesBlur()"
        />
        <m-validation
          [control]="numberValuesForm.controls['numberValues']"
        ></m-validation>
      </fieldset>
    </div>
  </form>

  <form
    [formGroup]="numberSingleValueForm"
    *ngIf="
      fraction.type === fractionTypeEnum.NumberIsGreaterThan ||
      fraction.type === fractionTypeEnum.NumberIsNotGreaterThan ||
      fraction.type === fractionTypeEnum.NumberIsGreaterThanOrEqualTo ||
      fraction.type === fractionTypeEnum.NumberIsNotGreaterThanOrEqualTo ||
      fraction.type === fractionTypeEnum.NumberIsLessThan ||
      fraction.type === fractionTypeEnum.NumberIsNotLessThan ||
      fraction.type === fractionTypeEnum.NumberIsLessThanOrEqualTo ||
      fraction.type === fractionTypeEnum.NumberIsNotLessThanOrEqualTo
    "
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <fieldset [disabled]="isDisabled === true">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="fractionNumberSingleValueInput"
          class="form-input border-s3 focus:border-m600 h-[36px] w-48 rounded"
          [ngClass]="{
            'border-r600':
              numberSingleValueForm.controls['numberValue1'].invalid &&
              numberSingleValueForm.controls['numberValue1'].touched
          }"
          formControlName="numberValue1"
          (blur)="numberSingleValueBlur()"
        />

        <m-validation
          [control]="numberSingleValueForm.controls['numberValue1']"
        ></m-validation>
      </fieldset>
    </div>
  </form>

  <div
    *ngIf="
      fraction.type === fractionTypeEnum.NumberIsBetween ||
      fraction.type === fractionTypeEnum.NumberIsNotBetween
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionBetweenOptionSelect
      [fixNgSelectBottom]="fractionBetweenOptionSelect"
      data-cy="fractionBetweenOptionSelect"
      class="popup-55 w-48"
      [ngClass]="{
        'cursor-default': isDisabled === true
      }"
      [items]="fractionNumberBetweenOptionsList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.numberBetweenOption"
      (change)="betweenOptionChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionBetweenOptionSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionBetweenOptionSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>
    </ng-select>
  </div>

  <form
    [formGroup]="numberBetweenForm"
    *ngIf="
      fraction.type === fractionTypeEnum.NumberIsBetween ||
      fraction.type === fractionTypeEnum.NumberIsNotBetween
    "
    class="flex flex-row space-x-5"
  >
    <div>
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <fieldset [disabled]="isDisabled === true">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionNumberBetweenFirstValueInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-48 rounded"
            [ngClass]="{
              'border-r600':
                numberBetweenForm.controls['numberBetweenFirstValue'].invalid &&
                numberBetweenForm.controls['numberBetweenFirstValue'].touched
            }"
            formControlName="numberBetweenFirstValue"
            (blur)="numberBetweenFirstValueBlur()"
          />
        </fieldset>
      </div>

      <m-validation
        [control]="numberBetweenForm.controls['numberBetweenFirstValue']"
      ></m-validation>
    </div>

    <div>
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <fieldset [disabled]="isDisabled === true">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionNumberBetweenSecondValueInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-48 rounded"
            [ngClass]="{
              'border-r600':
                numberBetweenForm.controls['numberBetweenSecondValue']
                  .invalid &&
                numberBetweenForm.controls['numberBetweenSecondValue'].touched
            }"
            formControlName="numberBetweenSecondValue"
            (blur)="numberBetweenSecondValueBlur()"
          />
        </fieldset>
      </div>

      <m-validation
        [control]="numberBetweenForm.controls['numberBetweenSecondValue']"
      ></m-validation>
    </div>
  </form>
</div>
